module.exports = __webpack_public_path__ + "img/气瓶柜.acebf4d7.jpg";